import React from 'react';
import { stripHtml, formatDateToMMDDYYYY } from '@private-crm-app/utils';

interface Props {
  updates: IFollowerUpdateEmail[];
}

export default function FollowerUpdates({ updates }: Props) {
  return (
    <div className="submission-detail__follower-updates">
      <div className="submission-detail__follower-updates-header">Updates</div>
      <div className="submission-detail__follower-updates-body">
        {updates.length === 0 ? (
          <p className="submission-detail__follower-updates-empty">No updates to show.</p>
        ) : (
          updates.map((update) => (
            <div key={update.id} className="submission-detail__follower-update-card">
              <div className="submission-detail__follower-update-meta">
                Sent on {formatDateToMMDDYYYY(update.createdAt)} by {update.senderName}
              </div>
              <div className="submission-detail__follower-update-body">{stripHtml(update.body)}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

